'use strict';

// Converted from CoffeeScript to JavaScript - ETNA Authenticator Login Modal Service
intra_module.service("loginModal", ['$uibModal', '$rootScope', function($uibModal, $rootScope) {
    
    var modalInstance = null;

    this.open = function(action) {
        if (modalInstance != null) {
            return modalInstance;
        }

        modalInstance = $uibModal.open({
            templateUrl: "partials/authenticator/" + action + "-modal-template.html",
            controller: "loginModalCtrl",
            backdrop: (action === 'logas') ? true : 'static',
            keyboard: (action === 'logas'),
            windowClass: 'sm-modal'
        });

        modalInstance.result.finally(function() {
            modalInstance = undefined;
        });

        return modalInstance;
    };

    return this;
}]);

intra_module.controller('loginModalCtrl', ['$scope', '$uibModalInstance', 'identity', function($scope, $uibModalInstance, identity) {
    // We implicitly assume that the template
    // decides what to put in credentials
    //   - login + password for login case
    //   - only login for logas case
    $scope.credentials = {};
    $scope.error = false;

    $scope.logout = function() {
        identity
            .$logout()
            .then(function() {
                $uibModalInstance.close();
            });
    };

    $scope.submit = function() {
        identity.login = $scope.credentials.login;
        identity.password = $scope.credentials.password;
        identity.$login()
            .then(function() {
                $scope.error = false;
                $uibModalInstance.close();
            })
            .catch(function(error) {
                $scope.error = { status: error.status };
            })
            .finally(function() {
                $scope.credentials.password = undefined;
            });
    };
}]);
